export const SETTING_INT = 'int';
export const SETTING_DECIMAL = 'decimal';
export const SETTING_STRING = 'string';
export const SETTING_ARRAY = 'array';
export const SETTING_OBJECT = 'object';
export const SETTING_BOOL = 'bool';
export const SETTING_TYPES = {
    [SETTING_INT]: 'Integer',
    [SETTING_DECIMAL]: 'Decimal',
    [SETTING_STRING]: 'String',
    [SETTING_ARRAY]: 'Array',
    [SETTING_OBJECT]: 'Object',
    [SETTING_BOOL]: 'Boolean',
};
